import axios from "axios";
import { url, invitationKey, auth_key, user_id } from "../../constants";
import https from "https";

export const getSearchResults = async (
  search,
  filters,
  Session_Object,
  page,
  tabValue,
  source
) => {
  if (search === "") {
    return "empty";
  }

  //    else if (cookie == null) {
  //     return "noCookies";
  //   }
  try {
    const stoqqyLang = window.localStorage.getItem("stoqqyLang");
    const response =
      tabValue === 2
        ? await axios.post(
            `${url}etfFunds/${search}`,
            {
              ...filters,
              Session_Object: null,
              page: page,
            },
            {
              cancelToken: source.token,
              headers: {
                "X-Api-Key": auth_key,
              },
              params: {
                User_ID: user_id,
              },
            }
          )
        : await axios.post(
            `${url}portfolio/${search}?Invitation=${invitationKey}&&language=${stoqqyLang}`,
            {
              ...filters,
              Session_Object: Session_Object,
              page: page,
            },
            {
              cancelToken: source.token,
              headers: {
                "X-Api-Key": auth_key,
              },
              params: {
                User_ID: user_id,
              },
            }
          );

    return response.data;
  } catch (error) {
    if (axios.isCancel(error)) {
      return "canceled";
    }
    console.log(error);
    return "error";
  }
};

export const getDirectAnswer = async (search) => {
  try {
    const response = await axios.get(`${url}directAnswer2/${search}`, {
      headers: {
        "X-Api-Key": auth_key,
      },
      params: {
        User_ID: user_id,
      },
    });
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getBookMarkResults = async (list) => {
  try {
    const response = await axios.get(
      `${url}selectbookmark/${invitationKey}?ListName=${list}`,
      {
        headers: {
          "X-Api-Key": auth_key,
        },
        params: {
          User_ID: user_id,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.log(error);
    return "error";
  }
};
